(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/* global $ */
var currencySelector = require("./global/currencySelector");

var jumpNavMenu = require("./global/jumpNavMenu");

var testimonials = require("./components/testimonials");

var tabs = require("./components/tabs");

var ProductTemplate = require("./templates/ProductTemplate");

$(function () {
  // ----
  // Global functionality
  // ----
  currencySelector();
  jumpNavMenu(); // ----
  // Globally-available components
  // ----

  testimonials();
  tabs(); // ----
  // Initialize templates
  // ----

  if ($("#shopify-section-product-template").length) {
    ProductTemplate("#shopify-section-product-template");
  }
});

},{"./components/tabs":2,"./components/testimonials":3,"./global/currencySelector":4,"./global/jumpNavMenu":5,"./templates/ProductTemplate":6}],2:[function(require,module,exports){
"use strict";

function init() {
  var $el = $(".tabs").length > 0 ? $(".tabs") : false;
  if (!$el) return;
  $el.each(function () {
    var $menu = $el.find(".tabs__menu");
    $menu.on("click", ".tabs__menu-item", handleClick);
  });
}

function handleClick() {
  if ($(this).hasClass("active")) {
    return;
  }

  var id = $(this).attr("data-id");
  var newActive = $("[data-id=".concat(id, "]"));
  newActive.each(function () {
    var $this = $(this);

    if ($this.hasClass("tabs__menu-item")) {
      $this.addClass("active").siblings().removeClass("active");
    } else {
      // // $(this).addClass("active").siblings().removeClass("active");
      $this.siblings().fadeOut();
      $this.delay(400).fadeIn();
    }
  });
}

module.exports = init;

},{}],3:[function(require,module,exports){
"use strict";

function init() {
  var $el = $(".TestimonialsSection").length > 0 ? $(".TestimonialsSection") : false;
  if (!$el) return;
  $el.each(function (index, section) {
    var $section = $(section);
    var sectionId = $section.attr("id");
    var $triggers = $section.find(".testimonials__triggers");
    $triggers.on("click", ".testimonials__trigger", handleClick);
  });
}

function handleClick() {
  if ($(this).hasClass("testimonials__trigger--active")) {
    return;
  }

  var id = this.id.split("--")[1];
  $(this).addClass("testimonials__trigger--active").siblings().removeClass("testimonials__trigger--active");
  $(".testimonials__slide").fadeOut(300);
  $("#testimonials__slide--".concat(id)).delay(400).fadeIn();
}

module.exports = init;

},{}],4:[function(require,module,exports){
"use strict";

var $selector = $(".shopify-currency-form select");

function init() {
  $selector.on("change", function () {
    $(this).parents("form").submit();
  });
}

module.exports = init;

},{}],5:[function(require,module,exports){
"use strict";

var $menuSection = "";
var $menu = "";
var $menuContainer = "";
var $pageAnchors = "";
var $siteNav = "";
var menuTop = 0;
var prevTop = 0;
var scrollingUp = false;
var anchorsObject = {};
var anchorStops = []; // Check to see if everything is in place, and if so, build the jump navigation menu and initalize listeners

function init() {
  $menuSection = $(".index-section--jump-nav-menu").first();
  $menu = $("#jump-nav-menu").first();
  $pageAnchors = $(".jump-nav-item a");

  if ($menu.length < 1 && $pageAnchors.length < 1) {
    return;
  } else if ($menu.length < 1) {
    console.warn("Warning: You have jump navigation anchors on this page, but have not included a jump navigation menu block.");
  } else if ($pageAnchors.length < 1) {
    $menuSection.hide();
    console.error("Error: There are no jump navigation anchors on this page to populate your jump navigation menu.");
  } else {
    // spin up the jump nav
    menuTop = $menu.offset().top;
    $menuContainer = $("#jump-nav-menu-container").first();
    $siteNav = $(".site-header").first();
    buildMenu();
    buildAnchorsObjet();
    $("a").smoothScroll();
    initListeners();
  }
} // make the jump nav based on how many anchors have been placed in the page by the user


function buildMenu() {
  var menuHTML = "";
  $pageAnchors.each(function (index) {
    var id = this.id;
    var menuTitle = $(this).attr("data-title");
    var text = this.innterText;
    var menuItem = "<li class=\"jump-nav-menu__link ".concat(index === 0 ? "active" : null, "\">\n      <a href=\"#").concat(id, "\">\n        ").concat(menuTitle ? menuTitle : text, "\n      </a>\n    </li>");
    menuHTML += menuItem;
  });
  $menuContainer.html("<ul>".concat(menuHTML, "</ul>"));
} // Make a list of the anchor locations so that we can update the active link on scroll


function buildAnchorsObjet() {
  anchorsObject = {};
  $pageAnchors.each(function (index) {
    if (index === 0) {
      anchorsObject[0] = this;
    } else {
      anchorsObject[parseInt($(this).offset().top)] = this;
    }
  });
  var stops = Object.keys(anchorsObject);
  anchorStops = stops.map(function (stop) {
    return parseInt(stop);
  }).sort();
} // listen to scroll, resize, and clicks


function initListeners() {
  var scrollTop = $(window).scrollTop();
  handleSticky(scrollTop);
  window.addEventListener("scroll", function () {
    requestAnimationFrame(function () {
      var scrollTop = $(window).scrollTop();
      handleSticky(scrollTop);
      handleActive(scrollTop);
    });
  });
  window.addEventListener("resize", function () {
    var scrollTop = $(window).scrollTop();
    buildAnchorsObjet();
    requestAnimationFrame(function () {
      menuTop = $menu.offset().top;
      handleSticky(scrollTop);
    });
  });
  $menu.on("click", ".jump-nav-menu__link", function () {
    handleMenuClick($(this), $(window).scrollTop());
  });
} // Check to see where the user is scrolled to on page load, scroll, or resize, and handle if the nav menu should be sticky and where it should be placed


function handleSticky(scrollTop) {
  if (scrollTop >= menuTop) {
    $menu.addClass("jump-nav-menu--sticky"); // check scroll direction

    if (scrollTop < prevTop) {
      handleScrollUp(scrollTop);
    } else if (scrollTop > prevTop) {
      handleScrollDown(scrollTop);
    }
  } else {
    $menu.removeClass("jump-nav-menu--sticky");
    handleScrollDown(scrollTop);
  }
} // Update the active link based on page position


function handleActive(scrollTop) {
  for (var i = 0; i < anchorStops.length; i++) {
    if (anchorStops[i] - 200 <= scrollTop && anchorStops[i + 1] > scrollTop || anchorStops[i] - 200 <= scrollTop && anchorStops[i + 1] === undefined) {
      var activeId = anchorsObject[anchorStops[i]].id;
      $("a[href=\"#".concat(activeId, "\"]")).closest(".jump-nav-menu__link").addClass("active").siblings().removeClass("active");
    }
  }
} // Measure if the link clicked takes the user up or down the page and make the appropriate changes to layout to accomodate the main navigation menu, which appears on scroll up & disappears on scroll down


function handleMenuClick($thisAnchor, currTop) {
  var anchorId = $thisAnchor.find("a").attr("href");
  var $destination = $(anchorId);
  var anchorTop = $destination.offset().top;

  if (currTop > anchorTop) {
    handleScrollUp(anchorTop);
  } else if (currTop < anchorTop) {
    handleScrollDown(anchorTop);
  }
}

function handleScrollUp(scrollTop) {
  // if user changed directions, then update settings
  if (scrollingUp === false) {
    var scrollUpTop = $siteNav.height() - 80;
    $menu.css("top", scrollUpTop);
    scrollingUp = true;
    $pageAnchors.each(function () {
      $(this).css("top", "".concat(($siteNav.height() + $menuContainer.height() + 40 + 50) * -1, "px"));
    });
  } // update scroll position


  prevTop = scrollTop;
}

function handleScrollDown(scrollTop) {
  if (scrollingUp === true) {
    var scrollDownTop = "-80px";
    $menu.css("top", scrollDownTop);
    scrollingUp = false;
    $pageAnchors.each(function () {
      $(this).css("top", "".concat(($menuContainer.height() + 40 + 50) * -1, "px"));
    });
  }

  prevTop = scrollTop;
}

module.exports = init;

},{}],6:[function(require,module,exports){
"use strict";

var isInit = false;
var $template = "";
var $productForm = "";
var $nixitProductForm = "";
var $checkout = "";
var $productContainer = "";
var variantQuantities = {};
var variantImages = {};
var lowStockThreshold = 0;
var $activeImage = "";
var $variantThumbnail = "";
var $thumbnails = "";

function init(selector) {
  if (isInit) {
    return;
    console.log("isInit");
  }

  $template = $("#shopify-section-product-template").contents();
  $productContainer = $("#product-template-container");
  $productForm = $template.find(".product-form");
  $nixitProductForm = $template.find("#product_form_1444881465416");
  $checkout = $(".cart-drawer__checkout");
  lowStockThreshold = $productContainer.attr("data-low-stock-threashold");
  $thumbnails = $template.find(".product-images__thumbnails");
  $activeImage = $template.find(".product-images--active").find(".product-images--activeRatio");
  $variantThumbnail = $template.find("#feature_variant");
  captureVariantInfo();
  $thumbnails.on("click", ".product-images__image", handleThumbnailClick);
  $productForm.change(handleFormChange);
  $nixitProductForm.submit(initTrackers);
  $checkout.click(trackCheckout);
  isInit = true;
} // Based on Tom Newton setup, JULY 2nd 2019


function initTrackers() {
  console.log("Event: add to cart - form submited");
  gtag("event", "conversion", {
    send_to: "AW-760268483/dyt6CMS-1aIBEMONw-oC"
  });
  pintrk("track", "addtocart");
  snaptr("track", "ADD_CART");
} // Based on Tom Newton setup, JULY 2nd 2019


function trackCheckout() {
  console.log("Checkout init");
  gtag("event", "conversion", {
    send_to: "AW-760268483/9U9wCKqp6aQBEMONw-oC"
  });
  snaptr("track", "START_CHECKOUT");
}

function captureVariantInfo() {
  console.log("hi");
  Array.from($productContainer[0].attributes).map(function (item) {
    if (item.localName.match("data-variant-")) {
      var variantId = item.localName.replace("data-variant-", "");
      variantQuantities[variantId] = parseInt(item.value);
    }

    if (item.localName.match("data-image-")) {
      var _variantId = item.localName.replace("data-image-", "");

      variantImages[_variantId] = item.value;
    }
  });
}

function handleFormChange() {
  setTimeout(function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var currentVariant = urlParams.get("variant");
    var variantStock = variantQuantities[currentVariant];
    var variantImage = variantImages[currentVariant];
    updateVariantImage(variantImage);
    $productContainer.removeClass("product-template--out-of-stock").removeClass("product-template--low-stock");

    if (variantStock === 0) {
      $productContainer.addClass("product-template--out-of-stock");
    } else if (variantStock <= lowStockThreshold) {
      $productContainer.addClass("product-template--low-stock");
    }
  }, 100);
}

function handleThumbnailClick() {
  var bgStyle = $(this).attr("style").split(": ")[1].split(";")[0];
  makeActive($(this));
  $activeImage.css("background-image", "".concat(bgStyle));
}

function updateVariantImage(variantImage) {
  $activeImage.css("background-image", "url(\"".concat(variantImage, "\")"));
  $variantThumbnail.css("background-image", "url(\"".concat(variantImage, "\")"));
  makeActive($variantThumbnail);
}

function makeActive($thumbnail) {
  $thumbnail.addClass("product-images__image--active").siblings().removeClass("product-images__image--active");
}

module.exports = init;

},{}]},{},[1]);
